import { ContainerType, DocType, OperateBoardEnum, OperateDocumentEnum } from '../common/Constant';
import Filter from '../utils/Filter';
import AbstractContainer from './AbstractContainer';
import { DocEvent } from './EventEnum';
import AdapterFactory from './strategy/AdapterFactory';
import log from 'loglevel';

/**
 * 文档类型
 *
 * @export
 * @class Document
 * @extends {AbstractContainer}
 */
export default class Document extends AbstractContainer {
  constructor(elId, uid, opts) {
    super(elId, uid, opts);
    this.type = ContainerType.DOCUMENT;
    // 具体的文档实例，由文档适配器工厂（AdapterFactory）创建
    this.doc = null;
    this.lastData = null;
  }

  operateDocument(type, ...args) {
    log.info(`operateDocument: ${type}, 参数为: ${args.join(',')}`);

    // 但凡操作文档之前，取消所有选中、编辑状态
    if (this.doo) {
      this.operateDoodle(OperateBoardEnum.DiscardActiveObject);
    }

    let doc = this.doc;
    switch (type) {
      case OperateDocumentEnum.SetDoc:
        if (!this._needChangeDoc(args[1])) {
          return;
        }
        this._setDocHandler(args[0], args[1], args[2]);
        this._initDoodleOperate();
        this._setDoodlePage();
        break;
      case OperateDocumentEnum.NextPage:
        doc.nextPage();
        this._setDoodlePage();
        break;
      case OperateDocumentEnum.PreviousPage:
        doc.prevPage();
        this._setDoodlePage();
        break;
      case OperateDocumentEnum.GotoPage:
        doc.gotoPage(args[0]);
        this._setDoodlePage();
        break;
      case OperateDocumentEnum.NextStep:
        doc.nextStep();
        this._setDoodlePage();
        break;
      case OperateDocumentEnum.PreviousStep:
        doc.prevStep();
        this._setDoodlePage();
        break;
      case OperateDocumentEnum.GotoStep:
        doc.gotoStep(...args);
        this._setDoodlePage();
        break;
      case OperateDocumentEnum.RemoveDocument:
        doc.removeDoc();
        break;
      case OperateDocumentEnum.Pageable:
        this.store.setKV('pageable', args[0]);
        break;
      case OperateDocumentEnum.Scale:
        log.info(`文档缩放倍数${args[0]}, 横坐标:${args[1]}, 纵坐标:${args[2]}`);
        if (!this.doc) return;
        const { node } = this.doc;
        if (!node) return;
        const scaleFactor = args[0];
        const xPos = args[1];
        const yPos = args[2];
        this.layout.scale(node, scaleFactor, xPos, yPos);
        break;
      case OperateDocumentEnum.Play:
        doc.play();
        break;
      case OperateDocumentEnum.Pause:
        doc.pause();
        break;
      default:
        log.warn(`Unidentified command type: ${type}.`);
        break;
    }
  }

  resize(w, h) {
    super.resize(w, h);

    if (!this.doc) {
      return;
    }

    this.doc.resize(w, h);
    const { node, imageSize } = this.doc;
    // const storeCW = this.store.getKV('cw')
    // const storeCH = this.store.getKV('ch')
    this.layout.layout(node, imageSize.width, imageSize.height, w, h);
  }

  destroy() {
    super.destroy();
    this.doc && this.doc.destroy();
  }
  setSelected(val) {
    super.setSelected(val);
    if (this.doc) {
      this.doc.setSelected(val);
    }
  }

  _changeDoc(v) {
    let temp = JSON.parse(v);
    // 构建模拟的新数据
    let buildData = {
      ext: temp.ext,
      slideIndex: temp.slideIndex || temp.show_page || temp.currentPage,
      slidesTotal: temp.slidesTotal || temp.page,
      hash: temp.hash,
      stepIndex: temp.stepIndex || temp.show_step || temp.currentStep,
      width: temp.width,
      height: temp.height,
      doc_type: temp.doc_type,
      docId: temp.docId
    };
    this.operateDocument(OperateDocumentEnum.SetDoc, temp.hash, JSON.stringify(buildData));
  }

  /**
   * 判断是否需要更换文档， 判断是否有文档实例、 判断显示类型是否一样、 判断文档扩展名是否一样 判断hash是否一样
   *
   * @param {*} v
   * @returns
   * @memberof Document
   */
  _needChangeDoc(v) {
    // console.log('typeof args[1]', typeof v, v);
    const doc = this.doc;
    // 如果没有实例化过文档， 直接返回true，需要进行更换文档
    if (!doc) return true;
    v = typeof v == 'string' ? JSON.parse(v) : v;
    if (v.doc_type) {
      const type = v.doc_type == 1 ? DocType.H5 : DocType.JPG;
      // 如果要显示的类型不一样，更换文档
      if (doc.docType != type) return true;
    }

    // 如果文件扩展名不一样， 更换文档（pdf， jpg这样的算是一样的，在ext 字段里存的是jpg）
    // if(doc.ext !== v.ext) {
    //   return true
    // }

    // 如果文档hash 都不一样了，那也更换文档
    if (doc.hash !== v.hash) return true;

    return false;
  }

  _setDocHandler(hash, arg, isRemote) {
    log.info('_setDocHandler', isRemote);
    if (this.option.basic.urlBase === '') {
      log.error('Base doc url is empty, could not set doc by hash');
      return;
    }
    if (hash == 1) {
      this.store.getKV('ee').dispatch('docNotExit', {
        docId: this.store.getKV('passThrough').docId,
        cid: this.store.getKV('cid')
      });
      log.info('文档不存在或被删除');
      return;
    }
    if (isRemote) {
      this.store.setKV('sender', 'vhallRemote');
    } else {
      const { userId } = this.store.getKV('passThrough');
      this.store.setKV('sender', userId);
    }

    // 换文档的话， 清空缓存
    if (this.doo && this.doc && this.doc.hash !== hash) {
      this.operateDoodle(OperateBoardEnum.ClearCache);
      this.operateDoodle(OperateBoardEnum.Clear);
    }

    let p = JSON.parse(arg);
    if (p['pageData']) {
      this.allData = p['pageData'];
    }

    let docWidth = p.width;
    let docHeight = p.height;
    this.store.setKV('imageWidth', docWidth);
    this.store.setKV('imageHeight', docHeight);

    if (this.doc) {
      this.doc.destroy();
    }

    Object.assign(p, this.option.basic);
    let docType = DocType.H5;
    if (p.doc_type) {
      docType = p.doc_type == 1 ? DocType.H5 : DocType.JPG;
      /** 修正docId可能为 undefined */
      let temp = this.store.getKV('passThrough');
      temp.docId = p.docId ? p.docId : p.document_id ? p.document_id : temp.docId;
      this.store.setKV('passThrough', temp);
    } else {
      docType = p.ext.indexOf('ppt') >= 0 ? DocType.H5 : DocType.JPG;
    }

    this.doc = AdapterFactory.createAdapter(docType);
    this.doc.setSelected(this.selected);
    this.doc.store = this.store;

    this.doc.init(p);
    this.doc.imageSize = { width: docWidth, height: docHeight };

    // 文档初始化完成后的回调
    this.doc.initCompleteCallBK = () => {
      log.info('initCompleteCallBK');
      // 因为PPT文档初次加载会跳转到第一页，延迟1秒后跳转到目标页面,如果不加延迟，直接跳转会导致页面加载不出来。
      // let isSelected = this.doc.docType === DocType.H5 ? this.selected : true;
      this.doc.setSelected(this.selected);
      // 如果iframe 放在页面上并隐藏，postMessage的消息响应时间大概在5s左右，所以要大于这个时间
      // 而如果显示的时候，这个响应时间是很快的
      // 谢特！iframe的坑？还是postMessage的坑？还是adapter的坑？还是我的坑？ 2019-08-15 00:11:26
      // 修正：解决响应时长过长的问题， 由于设置样式 display:none 导致， 隐藏改用visibility:hidden,显示使用visibility:visible 2019-09-06
      // let delay = isSelected ? 1000 : 6000
      let delay = this.doc.docType == DocType.H5 ? 4000 : 1000;
      let delayFun = setTimeout(() => {
        /**
         * 因为get-watch-info 这个接口返回的数据里
         * show_page 是正确的，page_data也是正确的，但是adapter 要先跳转到第一页，而page_data里的数据是目标页的。页码不相符，所以显示不对
         * 所以有了下面这段代码
         * 下面这段代码分为3个部分
         * part 1: 观看端加载完成后，跳转到首页（该问题截至到2020-09-19无解），然后无法绘制page_data，所以跳转首页后马上跳转到目标页
         * part 2: 对目标页内容进行绘制
         * part 3: 因为set data的数据不在发送事件，所以增加变量使其可以发送数据，如果不增加该段代码，观看端刷新后在进入，显示的是首页。因为目标页跳转使用的是set data。没有发消息出去
         */

        log.info(`isRemote: ${isRemote}, p: ${JSON.stringify(p)}`);
        if (isRemote) {
          this.store.setKV('sender', 'vhallRemote');
        } else {
          const { userId } = this.store.getKV('passThrough');
          this.store.setKV('sender', userId);
        }

        // part 1.
        this.operateDocument(OperateDocumentEnum.GotoPage, p['slideIndex'] || p['show_page'] || 0);
        this.operateDoodle(OperateBoardEnum.SetCurrentId, this.doc.currentPageHash);

        // part 2.
        if (this.lastData) {
          this.data = this.lastData;
          this.lastData = null;
        }

        // part 3.
        const slideIndex = p['slideIndex'] || p['show_page'] || 0;
        const stepIndex = p['stepIndex'] || p['show_step'] || 0;
        this.operateDocument(OperateDocumentEnum.GotoStep, slideIndex, stepIndex);
        this.operateDoodle(OperateBoardEnum.SetCurrentId, this.doc.currentPageHash);
        this.doc.inited = true;
        if (this.allData) {
          this.setAllData(this.allData);
        }
        this.operateDoodle(OperateBoardEnum.SetGraphic, -1);

        // 2021-11-18 yangxy add 处理某些h5文档打开后首页不自动播放问题
        if (slideIndex === 0 && this.doc._docType === 'h5') {
          this.operateDocument(OperateDocumentEnum.Play);
        }

        // 上报文档加载完成事件
        this.store.info.ee.dispatch('documentOnload', { cid: this.id });
        clearTimeout(delayFun);
      }, delay);
    };

    this.doc.cid = this.id;
    if (!this.doc.inited) {
      this.doc.createEl(this.dragAreaId, this.id);
    } else {
      let callBK = this.doc.initCompleteCallBK;
      callBK && callBK();
      callBK = null;
    }
    this.doc.hash = hash;
    let { node, imageSize } = this.doc;
    const storeCW = this.store.getKV('cw');
    const storeCH = this.store.getKV('ch');
    this.layout.layout(node, imageSize.width, imageSize.height, storeCW, storeCH);
    this.store.setKV('hash', hash);
    this.store.setKV('ext', p.ext);
  }

  _initDoodleOperate() {
    this.operateDoodle(OperateBoardEnum.Cacheable, this._cacheable);
    this.operateDoodle(OperateBoardEnum.Editable, this._editable);
  }

  get document() {
    return this.doc;
  }

  get pageInfo() {
    let obj = super.pageInfo;
    obj.doc = (this.doc && this.doc.info) || {};
    return obj;
  }

  set data(v) {
    log.info(`收到文档数据 set data, ${v}`);
    let temp;
    if (typeof v === 'string') {
      temp = JSON.parse(v);
    }
    if (!temp) return;
    super.data = temp;
    if (temp && temp.cid !== this.id) {
      return;
    }

    // 如果数据内容连hash都没有，那就清空各种数据
    if (!temp.hasOwnProperty('hash')) {
      this.doc && this.doc.destroy();

      if (this.doo) {
        this.operateDoodle(OperateBoardEnum.ClearCache);
        this.operateDoodle(OperateBoardEnum.Clear);
      }

      log.warn('warn', 'does not exist hash, destroy doc node and clear doodle');
      return;
    }

    let hash = temp['hash'];
    if (hash == '') {
      log.info(`文件数据Hash为空，不处理： ${v}`);
      return;
    }

    if (this._needChangeDoc(temp)) {
      log.info('need change Doc');
      this.lastData = v;
      this._changeDoc(v);
      return;
    }

    let datas = temp.command;

    const { userId } = this.store.getKV('passThrough');
    const senderId = datas[0]?.params?.senderId;

    if (userId === senderId) {
      log.info('自己发送的消息不处理');
      return;
    }
    // 只关心文档相关的数据内容，画笔数据由super进行管理
    datas.forEach(data => {
      const p = data.params;
      switch (data.event) {
        case DocEvent.STEP_CHANGE:
          this.store.setKV('sender', p.senderId);
          this.operateDocument(OperateDocumentEnum.GotoStep, p.slideIndex, p.stepIndex);
          break;
        case DocEvent.PAGE_CHANGE:
          // 设置画笔当前页
          const hash = this.doc.currentPageHash;
          this.operateDoodle(OperateBoardEnum.SetCurrentId, hash);
          this.store.setKV('sender', p.senderId);
          this.operateDocument(OperateDocumentEnum.GotoPage, p.slideIndex);
          break;
        default:
          break;
      }
    });
  }

  get data() {
    return super.data;
  }

  _setDoodlePage() {
    if (!this.doc) {
      return;
    }
    this.operateDoodle(OperateBoardEnum.SetCurrentId, this.doc.currentPageHash);
  }

  /**
   * 获取文档缩略图列表
   *
   * @returns
   * @memberof Document
   */
  getThumbnailList() {
    const { urlBase } = this.option.basic;
    const { info } = this.doc;
    const { hash, slidesTotal } = info;
    let result = [];

    for (let i = 1; i <= slidesTotal; i += 1) {
      result.push(`${urlBase}${hash}/${i}_s.jpg`);
    }
    return result;
  }

  setAllData(allData) {
    super.setAllData(allData);

    if (this.doc.inited) {
      let data = allData;
      if (typeof allData === 'string') {
        data = JSON.parse(allData);
      }

      const filter = new Filter();
      // 筛选完的数据
      let filterData = filter.exec(data);
      while (filterData.length) {
        let itemData = filterData.shift();
        itemData.doc_type = this.doc.docType === DocType.H5 ? 1 : 2;
        this.data = JSON.stringify(itemData);
      }

      this.allData = [];
    }
  }

  set pageable(v) {
    this._pageable = v;
    this.operateDocument(OperateDocumentEnum.Pageable, v);
  }

  get pageable() {
    return this._pageable;
  }

  get docInstance() {
    return this.doc;
  }
}
